import {
  apiNewtailRetailMedia,
  apiNewtailRetailMediaStaging
} from '../services'

export const getNewtailMedia = async ({
  publisherId,
  body,
  isStaging
}: GetNewtailMediaProps) => {
  const service = isStaging
    ? apiNewtailRetailMediaStaging
    : apiNewtailRetailMedia

  const url = `/${publisherId}`

  return service.post<ResponseRequestAds>(url, body)
}
